import { makeStyles, Theme, Typography, createStyles } from "@material-ui/core"
import React, { FC } from "react";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
   
    root: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(12),
        width: 800,
        margin: "auto",
    },
    paragraph: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
    }
  }),
);

const TermsOfService: FC = () => {
    const classes = useStyles();

    return <div className={classes.root}>
        <Typography variant="h4">
            Vivani - Terms and conditions
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            These terms and conditions (&quot;Terms&quot;, &quot;Agreement&quot;) are an agreement between Vivani doo, Svilajnac
            (&quot;Vivani doo, Svilajnac&quot;, &quot;us&quot;, &quot;we&quot; or &quot;our&quot;) and you (&quot;User&quot;,
            &quot;you&quot; or &quot;your&quot;). This Agreement sets forth the general terms and conditions of your use of the
            <a target="_blank" rel="nofollow noopener noreferrer" href="https://meet.rs"> meet.rs</a> website and any of its products or services
            (collectively, &quot;Website&quot; or &quot;Services&quot;).
        </Typography>
        <Typography variant="h5">
            Accounts and membership
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            If you create an account on the Website, you are responsible for maintaining the security of your account and you are fully responsible 
            for all activities that occur under the account and any other actions taken in connection with it. 
            We may, but have no obligation to, monitor and review new accounts before you may sign in and use our Services. 
            Providing false contact information of any kind may result in the termination of your account. 
            You must immediately notify us of any unauthorized uses of your account or any other breaches of security. 
            We will not be liable for any acts or omissions by you, including any damages of any kind incurred as a result of such acts or omissions.
        </Typography>
        
        <Typography variant="h5">
            Billing and payments
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            You shall pay all fees or charges to your account in accordance with the fees, charges, and billing terms in effect at the time a fee or charge
             is due and payable. Where Services are offered on a free trial basis, payment may be required after the free trial period ends, 
             and not when you enter your billing details (which may be required prior to the commencement of the free trial period). 
             Sensitive and private data exchange between the Website and its Users happens over a SSL secured communication channel and is encrypted and protected with digital signatures. 
             If, in our judgment, your purchase constitutes a high-risk transaction, we will require you to provide us with a copy of your valid government-issued photo identification, 
             and possibly a copy of a recent bank statement for the credit or debit card used for the purchase. 
             We reserve the right to change products and product pricing at any time.
        </Typography>

        
        <Typography variant="h5">
            Accuracy of information
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            Occasionally there may be information on the Website that contains typographical errors, inaccuracies or omissions that may relate to promotions and offers. 
            We reserve the right to correct any errors, inaccuracies or omissions, and to change or update information or cancel orders if any information on the Website 
            or on any related Service is inaccurate at any time without prior notice (including after you have submitted your order). 
            We undertake no obligation to update, amend or clarify information on the Website including, without limitation, pricing information, except as required by law. 
            No specified update or refresh date applied on the Website should be taken to indicate that all information on the Website or on any related Service 
            has been modified or updated.
        </Typography>

        
        <Typography variant="h5">
            Uptime guarantee
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            We offer a Service uptime guarantee of 99% of available time per month. 
            If we fail to maintain this service uptime guarantee in a particular month (as solely determined by us), you may contact us and request a credit off your Service fee 
            for that month. The credit may be used only for the purchase of further products and services from us, and is exclusive of any applicable taxes. 
            The service uptime guarantee does not apply to service interruptions caused by: 
            (1) periodic scheduled maintenance or repairs we may undertake from time to time; 
            (2) interruptions caused by you or your activities; 
            (3) outages that do not affect core Service functionality; 
            (4) causes beyond our control or that are not reasonably foreseeable; and 
            (5) outages related to the reliability of certain programming environments.
        </Typography>

        
        <Typography variant="h5">
            Backups
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            We are not responsible for Content residing on the Website. In no event shall we be held liable for any loss of any Content. 
            It is your sole responsibility to maintain appropriate backup of your Content. 
            Notwithstanding the foregoing, on some occasions and in certain circumstances, with absolutely no obligation, we may be able to restore some 
            or all of your data that has been deleted as of a certain date and time when we may have backed up data for our own purposes. 
            We make no guarantee that the data you need will be available.
        </Typography>

        
        <Typography variant="h5">
            Links to other websites
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            Although this Website may link to other websites, we are not, directly or indirectly, implying any approval, 
            association, sponsorship, endorsement, or affiliation with any linked website, unless specifically stated herein. 
            We are not responsible for examining or evaluating, and we do not warrant the offerings of, any businesses or individuals or the content of their websites. 
            We do not assume any responsibility or liability for the actions, products, services, and content of any other third-parties. 
            You should carefully review the legal statements and other conditions of use of any website which you access through a link from this Website. 
            Your linking to any other off-site websites is at your own risk.
        </Typography>

        
        <Typography variant="h5">
            Intellectual property rights
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            This Agreement does not transfer to you any intellectual property owned by Vivani doo, Svilajnac or third-parties, and all rights, titles, and interests 
            in and to such property will remain (as between the parties) solely with Vivani doo, Svilajnac. 
            All trademarks, service marks, graphics and logos used in connection with our Website or Services, are trademarks or registered trademarks of Vivani doo, Svilajnac 
            or Vivani doo, Svilajnac licensors. Other trademarks, service marks, graphics and logos used in connection with our Website or Services may be the trademarks 
            of other third-parties. Your use of our Website and Services grants you no right or license to reproduce or otherwise use any Vivani doo, Svilajnac or third-party trademarks.
        </Typography>

        <Typography variant="h5">
            Limitation of liability
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            To the fullest extent permitted by applicable law, in no event will Vivani doo, Svilajnac, its affiliates, officers, directors, employees, agents, suppliers or licensors 
            be liable to any person for 
            (a): any indirect, incidental, special, punitive, cover or consequential damages (including, without limitation, damages for lost profits, revenue, 
                 sales, goodwill, use of content, impact on business, business interruption, loss of anticipated savings, loss of business opportunity) however caused, 
                under any theory of liability, including, without limitation, contract, tort, warranty, breach of statutory duty, negligence or otherwise, even if Vivani doo, Svilajnac 
                has been advised as to the possibility of such damages or could have foreseen such damages. 
                To the maximum extent permitted by applicable law, the aggregate liability of Vivani doo, Svilajnac and its affiliates, officers, employees, agents, suppliers and licensors, 
                relating to the services will be limited to an amount greater of one dollar or any amounts actually paid in cash by you to Vivani doo, Svilajnac for the prior one month period 
                prior to the first event or occurrence giving rise to such liability. The limitations and exclusions also apply if this remedy does not fully compensate you 
                for any losses or fails of its essential purpose.
        </Typography>

        <Typography variant="h5">
            Changes and amendments
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            We reserve the right to modify this Agreement or its policies relating to the Website or Services at any time, effective upon posting of an updated version of this Agreement 
            on the Website. When we do, we will post a notification on the main page of our Website. Continued use of the Website after any such changes shall constitute your consent 
            to such changes.
        </Typography>
        
        <Typography variant="h5">
            Acceptance of these terms
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            You acknowledge that you have read this Agreement and agree to all its terms and conditions. 
            By using the Website or its Services you agree to be bound by this Agreement. 
            If you do not agree to abide by the terms of this Agreement, you are not authorized to use or access the Website and its Services.
        </Typography>
        
        <Typography variant="h5">
            Contacting us
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            If you would like to contact us to understand more about this Agreement or wish to contact us concerning any matter relating to it, you may send an email to office@meet.rs
        </Typography>
        
        <Typography variant="body1" className={classes.paragraph}>
            This document was last updated on July 1, 2020          
        </Typography>


    </div>;

}

export default TermsOfService;